import { createSlice } from "@reduxjs/toolkit";

import settingApi from "../api/setting";
import { AppSettingModel, PermissionModel } from "../types";

const initialState = {
  appSettings: [],
  permissions: [],
} as SettingState;

const slice = createSlice({
  name: "setting",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      settingApi.endpoints.getAppSettings.matchFulfilled,
      (state, { payload }: { payload: AppSettingModel[] }) => {
        return { ...state, appSettings: payload };
      }
    );
    builder.addMatcher(
      settingApi.endpoints.updateAppSetting.matchFulfilled,
      (state, { payload }: { payload: AppSettingModel[] }) => {
        return { ...state, appSettings: payload };
      }
    );
    builder.addMatcher(
      settingApi.endpoints.getPermissions.matchFulfilled,
      (state, { payload }: { payload: PermissionModel[] }) => {
        return { ...state, permissions: payload };
      }
    );
    builder.addMatcher(
      settingApi.endpoints.addEditPermission.matchFulfilled,
      (state, { payload }: { payload: PermissionModel[] }) => {
        return { ...state, permissions: payload };
      }
    );
  },
});

export const setting = slice.reducer;

export interface SettingState {
  appSettings: AppSettingModel[];
  permissions: PermissionModel[];
}
